module.exports = __webpack_public_path__ + "static/media/UnlockProduct.bf474792.svg";